import React from 'react';

import './RadioButtons.scss';

const RadioButtonsImages = (props) => (
    <div className={props.parentClassName}>
        {props.options.map((button, index) => (
            <div className={`radio-button-images ${props.className}`} key={index} onClick={() => props.changeChoice(button)}>
                <img src={`./assets/${props.prefix}${button}.png`} />
                <div className="button">
                    {props.value === button ? <div className="active"></div>: ''}
                </div>
            </div>
        ))}
    </div>
);

export default RadioButtonsImages;